"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneNonReference = cloneNonReference;

/** 无引用克隆 */
function cloneNonReference(data) {
  try {
    return JSON.parse(JSON.stringify(data));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('复制错误, 请确认数据是否循环引用');
  }
}